/* eslint-disable */
import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {
  assertParamExists,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  DUMMY_BASE_URL,
  createRequestFunction,
} from '../common';
import {
  AuthLoginRequest,
  AuthLoginResponse,
  AuthorizeCallbackRsp,
  AuthorizeProviderRsp,
  AuthRefreshRequest,
  AuthRefreshResponse,
  AuthVerifyRequest,
  AuthVerifyResponse,
  DeviceLoginRsp,
} from '../types/auth';
import {
  DeviceLoginReq,
  EmailActiveReq,
  AuthLogoutRequest,
  AuthRegisterReq,
  AuthRegisterRequest,
  AuthAuthorizeRsp,
  AuthSendRegisterEmailReq,
  AuthServiceAuthorizeCallbackProviderEnum,
  AuthServiceAuthorizeProviderEnum,
  ResetPasswordReq,
  SendForgetPasswordEmailReq,
} from '../types/auth';

/**
 * AuthServiceApi - axios parameter creator
 * @export
 */
export const AuthServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 第三方授权登录
     * @summary 第三方授权登录
     * @param {AuthServiceAuthorizeProviderEnum} provider 第三方登录类型: github, google
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceAuthorize: async (
      provider: AuthServiceAuthorizeProviderEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'provider' is not null or undefined
      assertParamExists('authServiceAuthorize', 'provider', provider);
      const localVarPath = `/auth/authorize/{provider}`.replace(
        `{${'provider'}}`,
        encodeURIComponent(String(provider))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 第三方授权登录回调
     * @summary 第三方授权登录回调
     * @param {AuthServiceAuthorizeCallbackProviderEnum} provider
     * @param {string} [code]
     * @param {string} [state]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceAuthorizeCallback: async (
      provider: AuthServiceAuthorizeCallbackProviderEnum,
      code?: string,
      state?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'provider' is not null or undefined
      assertParamExists('authServiceAuthorizeCallback', 'provider', provider);
      const localVarPath = `/auth/authorize/{provider}/callback`.replace(
        `{${'provider'}}`,
        encodeURIComponent(String(provider))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (code !== undefined) {
        localVarQueryParameter['code'] = code;
      }

      if (state !== undefined) {
        localVarQueryParameter['state'] = state;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 第三方登录授权种类列表
     * @summary 第三方登录授权种类列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceAuthorizeProvider: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/authorize_providers`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 设备登录
     * @summary 设备登录
     * @param {DeviceLoginReq} deviceLoginReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceDeviceLogin: async (
      deviceLoginReq: DeviceLoginReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deviceLoginReq' is not null or undefined
      assertParamExists('authServiceDeviceLogin', 'deviceLoginReq', deviceLoginReq);
      const localVarPath = `/auth/device_login`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deviceLoginReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 邮箱激活
     * @summary 邮箱激活
     * @param {EmailActiveReq} emailActiveReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceEmailActive: async (
      emailActiveReq: EmailActiveReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'emailActiveReq' is not null or undefined
      assertParamExists('authServiceEmailActive', 'emailActiveReq', emailActiveReq);
      const localVarPath = `/auth/email_activate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        emailActiveReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户登录
     * @summary 用户登录
     * @param {AuthLoginRequest} authLoginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceLogin: async (
      authLoginRequest: AuthLoginRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'authLoginRequest' is not null or undefined
      assertParamExists('authServiceLogin', 'authLoginRequest', authLoginRequest);
      const localVarPath = `/auth/login`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        authLoginRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户登出
     * @summary 用户登出
     * @param {AuthLogoutRequest} authLogoutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceLogout: async (
      authLogoutRequest: AuthLogoutRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'authLogoutRequest' is not null or undefined
      assertParamExists('authServiceLogout', 'authLogoutRequest', authLogoutRequest);
      const localVarPath = `/auth/logout`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        authLogoutRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * token 过期续期   认证 token 过期重新续期
     * @summary token 过期续期   认证 token 过期重新续期
     * @param {AuthRefreshRequest} authRefreshRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceRefresh: async (
      authRefreshRequest: AuthRefreshRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'authRefreshRequest' is not null or undefined
      assertParamExists('authServiceRefresh', 'authRefreshRequest', authRefreshRequest);
      const localVarPath = `/auth/refresh`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        authRefreshRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户注册
     * @summary 用户注册
     * @param {AuthRegisterReq} authRegisterReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceRegister: async (
      authRegisterReq: AuthRegisterReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'authRegisterReq' is not null or undefined
      assertParamExists('authServiceRegister', 'authRegisterReq', authRegisterReq);
      const localVarPath = `/auth/register`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        authRegisterReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户注册回调
     * @summary 用户注册回调
     * @param {AuthRegisterRequest} authRegisterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceRegisterCallback: async (
      authRegisterRequest: AuthRegisterRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'authRegisterRequest' is not null or undefined
      assertParamExists('authServiceRegisterCallback', 'authRegisterRequest', authRegisterRequest);
      const localVarPath = `/auth/register_callback`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        authRegisterRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 重置密码   重置密码需要验证码
     * @summary 重置密码   重置密码需要验证码
     * @param {ResetPasswordReq} resetPasswordReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceResetPassword: async (
      resetPasswordReq: ResetPasswordReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'resetPasswordReq' is not null or undefined
      assertParamExists('authServiceResetPassword', 'resetPasswordReq', resetPasswordReq);
      const localVarPath = `/auth/reset_password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        resetPasswordReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 忘记密码邮件发送
     * @summary 忘记密码邮件发送
     * @param {SendForgetPasswordEmailReq} sendForgetPasswordEmailReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceSendForgetPasswordEmail: async (
      sendForgetPasswordEmailReq: SendForgetPasswordEmailReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'sendForgetPasswordEmailReq' is not null or undefined
      assertParamExists(
        'authServiceSendForgetPasswordEmail',
        'sendForgetPasswordEmailReq',
        sendForgetPasswordEmailReq
      );
      const localVarPath = `/auth/send_forget_password_email`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        sendForgetPasswordEmailReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户注册邀请
     * @summary 用户注册邀请
     * @param {AuthSendRegisterEmailReq} authSendRegisterEmailReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceSendRegisterEmail: async (
      authSendRegisterEmailReq: AuthSendRegisterEmailReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'authSendRegisterEmailReq' is not null or undefined
      assertParamExists(
        'authServiceSendRegisterEmail',
        'authSendRegisterEmailReq',
        authSendRegisterEmailReq
      );
      const localVarPath = `/auth/send_register_email`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        authSendRegisterEmailReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 验证 token 是否过期
     * @summary 验证 token 是否过期
     * @param {AuthVerifyRequest} authVerifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceVerify: async (
      authVerifyRequest: AuthVerifyRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'authVerifyRequest' is not null or undefined
      assertParamExists('authServiceVerify', 'authVerifyRequest', authVerifyRequest);
      const localVarPath = `/auth/verify`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        authVerifyRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthServiceApi - functional programming interface
 * @export
 */
export const AuthServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * 第三方授权登录
     * @summary 第三方授权登录
     * @param {AuthServiceAuthorizeProviderEnum} provider 第三方登录类型: github, google
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authServiceAuthorize(
      provider: AuthServiceAuthorizeProviderEnum,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthAuthorizeRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceAuthorize(
        provider,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthServiceApi.authServiceAuthorize']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 第三方授权登录回调
     * @summary 第三方授权登录回调
     * @param {AuthServiceAuthorizeCallbackProviderEnum} provider
     * @param {string} [code]
     * @param {string} [state]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authServiceAuthorizeCallback(
      provider: AuthServiceAuthorizeCallbackProviderEnum,
      code?: string,
      state?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizeCallbackRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceAuthorizeCallback(
        provider,
        code,
        state,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthServiceApi.authServiceAuthorizeCallback']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 第三方登录授权种类列表
     * @summary 第三方登录授权种类列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authServiceAuthorizeProvider(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizeProviderRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceAuthorizeProvider(
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthServiceApi.authServiceAuthorizeProvider']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 设备登录
     * @summary 设备登录
     * @param {DeviceLoginReq} deviceLoginReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authServiceDeviceLogin(
      deviceLoginReq: DeviceLoginReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceLoginRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceDeviceLogin(
        deviceLoginReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthServiceApi.authServiceDeviceLogin']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 邮箱激活
     * @summary 邮箱激活
     * @param {EmailActiveReq} emailActiveReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authServiceEmailActive(
      emailActiveReq: EmailActiveReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceEmailActive(
        emailActiveReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthServiceApi.authServiceEmailActive']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户登录
     * @summary 用户登录
     * @param {AuthLoginRequest} authLoginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authServiceLogin(
      authLoginRequest: AuthLoginRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLoginResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceLogin(
        authLoginRequest,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthServiceApi.authServiceLogin']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户登出
     * @summary 用户登出
     * @param {AuthLogoutRequest} authLogoutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authServiceLogout(
      authLogoutRequest: AuthLogoutRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceLogout(
        authLogoutRequest,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthServiceApi.authServiceLogout']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * token 过期续期   认证 token 过期重新续期
     * @summary token 过期续期   认证 token 过期重新续期
     * @param {AuthRefreshRequest} authRefreshRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authServiceRefresh(
      authRefreshRequest: AuthRefreshRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthRefreshResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceRefresh(
        authRefreshRequest,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthServiceApi.authServiceRefresh']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户注册
     * @summary 用户注册
     * @param {AuthRegisterReq} authRegisterReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authServiceRegister(
      authRegisterReq: AuthRegisterReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceRegister(
        authRegisterReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthServiceApi.authServiceRegister']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户注册回调
     * @summary 用户注册回调
     * @param {AuthRegisterRequest} authRegisterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authServiceRegisterCallback(
      authRegisterRequest: AuthRegisterRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceRegisterCallback(
        authRegisterRequest,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthServiceApi.authServiceRegisterCallback']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 重置密码   重置密码需要验证码
     * @summary 重置密码   重置密码需要验证码
     * @param {ResetPasswordReq} resetPasswordReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authServiceResetPassword(
      resetPasswordReq: ResetPasswordReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceResetPassword(
        resetPasswordReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthServiceApi.authServiceResetPassword']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 忘记密码邮件发送
     * @summary 忘记密码邮件发送
     * @param {SendForgetPasswordEmailReq} sendForgetPasswordEmailReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authServiceSendForgetPasswordEmail(
      sendForgetPasswordEmailReq: SendForgetPasswordEmailReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceSendForgetPasswordEmail(
        sendForgetPasswordEmailReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthServiceApi.authServiceSendForgetPasswordEmail']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户注册邀请
     * @summary 用户注册邀请
     * @param {AuthSendRegisterEmailReq} authSendRegisterEmailReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authServiceSendRegisterEmail(
      authSendRegisterEmailReq: AuthSendRegisterEmailReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceSendRegisterEmail(
        authSendRegisterEmailReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthServiceApi.authServiceSendRegisterEmail']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 验证 token 是否过期
     * @summary 验证 token 是否过期
     * @param {AuthVerifyRequest} authVerifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authServiceVerify(
      authVerifyRequest: AuthVerifyRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthVerifyResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceVerify(
        authVerifyRequest,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthServiceApi.authServiceVerify']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AuthServiceApi - factory interface
 * @export
 */
export const AuthServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AuthServiceApiFp(configuration);
  return {
    /**
     * 第三方授权登录
     * @summary 第三方授权登录
     * @param {AuthServiceAuthorizeProviderEnum} provider 第三方登录类型: github, google
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceAuthorize(
      provider: AuthServiceAuthorizeProviderEnum,
      options?: any
    ): AxiosPromise<AuthAuthorizeRsp> {
      return localVarFp
        .authServiceAuthorize(provider, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 第三方授权登录回调
     * @summary 第三方授权登录回调
     * @param {AuthServiceAuthorizeCallbackProviderEnum} provider
     * @param {string} [code]
     * @param {string} [state]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceAuthorizeCallback(
      provider: AuthServiceAuthorizeCallbackProviderEnum,
      code?: string,
      state?: string,
      options?: any
    ): AxiosPromise<AuthorizeCallbackRsp> {
      return localVarFp
        .authServiceAuthorizeCallback(provider, code, state, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 第三方登录授权种类列表
     * @summary 第三方登录授权种类列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceAuthorizeProvider(options?: any): AxiosPromise<AuthorizeProviderRsp> {
      return localVarFp
        .authServiceAuthorizeProvider(options)
        .then(request => request(axios, basePath));
    },
    /**
     * 设备登录
     * @summary 设备登录
     * @param {DeviceLoginReq} deviceLoginReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceDeviceLogin(
      deviceLoginReq: DeviceLoginReq,
      options?: any
    ): AxiosPromise<DeviceLoginRsp> {
      return localVarFp
        .authServiceDeviceLogin(deviceLoginReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 邮箱激活
     * @summary 邮箱激活
     * @param {EmailActiveReq} emailActiveReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceEmailActive(emailActiveReq: EmailActiveReq, options?: any): AxiosPromise<void> {
      return localVarFp
        .authServiceEmailActive(emailActiveReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 用户登录
     * @summary 用户登录
     * @param {AuthLoginRequest} authLoginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceLogin(
      authLoginRequest: AuthLoginRequest,
      options?: any
    ): AxiosPromise<AuthLoginResponse> {
      return localVarFp
        .authServiceLogin(authLoginRequest, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 用户登出
     * @summary 用户登出
     * @param {AuthLogoutRequest} authLogoutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceLogout(authLogoutRequest: AuthLogoutRequest, options?: any): AxiosPromise<void> {
      return localVarFp
        .authServiceLogout(authLogoutRequest, options)
        .then(request => request(axios, basePath));
    },
    /**
     * token 过期续期   认证 token 过期重新续期
     * @summary token 过期续期   认证 token 过期重新续期
     * @param {AuthRefreshRequest} authRefreshRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceRefresh(
      authRefreshRequest: AuthRefreshRequest,
      options?: any
    ): AxiosPromise<AuthRefreshResponse> {
      return localVarFp
        .authServiceRefresh(authRefreshRequest, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 用户注册
     * @summary 用户注册
     * @param {AuthRegisterReq} authRegisterReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceRegister(authRegisterReq: AuthRegisterReq, options?: any): AxiosPromise<void> {
      return localVarFp
        .authServiceRegister(authRegisterReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 用户注册回调
     * @summary 用户注册回调
     * @param {AuthRegisterRequest} authRegisterRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceRegisterCallback(
      authRegisterRequest: AuthRegisterRequest,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .authServiceRegisterCallback(authRegisterRequest, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 重置密码   重置密码需要验证码
     * @summary 重置密码   重置密码需要验证码
     * @param {ResetPasswordReq} resetPasswordReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceResetPassword(
      resetPasswordReq: ResetPasswordReq,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .authServiceResetPassword(resetPasswordReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 忘记密码邮件发送
     * @summary 忘记密码邮件发送
     * @param {SendForgetPasswordEmailReq} sendForgetPasswordEmailReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceSendForgetPasswordEmail(
      sendForgetPasswordEmailReq: SendForgetPasswordEmailReq,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .authServiceSendForgetPasswordEmail(sendForgetPasswordEmailReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 用户注册邀请
     * @summary 用户注册邀请
     * @param {AuthSendRegisterEmailReq} authSendRegisterEmailReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceSendRegisterEmail(
      authSendRegisterEmailReq: AuthSendRegisterEmailReq,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .authServiceSendRegisterEmail(authSendRegisterEmailReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 验证 token 是否过期
     * @summary 验证 token 是否过期
     * @param {AuthVerifyRequest} authVerifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authServiceVerify(
      authVerifyRequest: AuthVerifyRequest,
      options?: any
    ): AxiosPromise<AuthVerifyResponse> {
      return localVarFp
        .authServiceVerify(authVerifyRequest, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AuthServiceApi - object-oriented interface
 * @export
 * @class AuthServiceApi
 * @extends {BaseAPI}
 */
export class AuthServiceApi extends BaseAPI {
  /**
   * 第三方授权登录
   * @summary 第三方授权登录
   * @param {AuthServiceAuthorizeProviderEnum} provider 第三方登录类型: github, google
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthServiceApi
   */
  public authServiceAuthorize(
    provider: AuthServiceAuthorizeProviderEnum,
    options?: RawAxiosRequestConfig
  ) {
    return AuthServiceApiFp(this.configuration)
      .authServiceAuthorize(provider, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 第三方授权登录回调
   * @summary 第三方授权登录回调
   * @param {AuthServiceAuthorizeCallbackProviderEnum} provider
   * @param {string} [code]
   * @param {string} [state]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthServiceApi
   */
  public authServiceAuthorizeCallback(
    provider: AuthServiceAuthorizeCallbackProviderEnum,
    code?: string,
    state?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AuthServiceApiFp(this.configuration)
      .authServiceAuthorizeCallback(provider, code, state, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 第三方登录授权种类列表
   * @summary 第三方登录授权种类列表
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthServiceApi
   */
  public authServiceAuthorizeProvider(options?: RawAxiosRequestConfig) {
    return AuthServiceApiFp(this.configuration)
      .authServiceAuthorizeProvider(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 设备登录
   * @summary 设备登录
   * @param {DeviceLoginReq} deviceLoginReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthServiceApi
   */
  public authServiceDeviceLogin(deviceLoginReq: DeviceLoginReq, options?: RawAxiosRequestConfig) {
    return AuthServiceApiFp(this.configuration)
      .authServiceDeviceLogin(deviceLoginReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 邮箱激活
   * @summary 邮箱激活
   * @param {EmailActiveReq} emailActiveReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthServiceApi
   */
  public authServiceEmailActive(emailActiveReq: EmailActiveReq, options?: RawAxiosRequestConfig) {
    return AuthServiceApiFp(this.configuration)
      .authServiceEmailActive(emailActiveReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户登录
   * @summary 用户登录
   * @param {AuthLoginRequest} authLoginRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthServiceApi
   */
  public authServiceLogin(authLoginRequest: AuthLoginRequest, options?: RawAxiosRequestConfig) {
    return AuthServiceApiFp(this.configuration)
      .authServiceLogin(authLoginRequest, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户登出
   * @summary 用户登出
   * @param {AuthLogoutRequest} authLogoutRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthServiceApi
   */
  public authServiceLogout(authLogoutRequest: AuthLogoutRequest, options?: RawAxiosRequestConfig) {
    return AuthServiceApiFp(this.configuration)
      .authServiceLogout(authLogoutRequest, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * token 过期续期   认证 token 过期重新续期
   * @summary token 过期续期   认证 token 过期重新续期
   * @param {AuthRefreshRequest} authRefreshRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthServiceApi
   */
  public authServiceRefresh(
    authRefreshRequest: AuthRefreshRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AuthServiceApiFp(this.configuration)
      .authServiceRefresh(authRefreshRequest, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户注册
   * @summary 用户注册
   * @param {AuthRegisterReq} authRegisterReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthServiceApi
   */
  public authServiceRegister(authRegisterReq: AuthRegisterReq, options?: RawAxiosRequestConfig) {
    return AuthServiceApiFp(this.configuration)
      .authServiceRegister(authRegisterReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户注册回调
   * @summary 用户注册回调
   * @param {AuthRegisterRequest} authRegisterRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthServiceApi
   */
  public authServiceRegisterCallback(
    authRegisterRequest: AuthRegisterRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AuthServiceApiFp(this.configuration)
      .authServiceRegisterCallback(authRegisterRequest, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 重置密码   重置密码需要验证码
   * @summary 重置密码   重置密码需要验证码
   * @param {ResetPasswordReq} resetPasswordReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthServiceApi
   */
  public authServiceResetPassword(
    resetPasswordReq: ResetPasswordReq,
    options?: RawAxiosRequestConfig
  ) {
    return AuthServiceApiFp(this.configuration)
      .authServiceResetPassword(resetPasswordReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 忘记密码邮件发送
   * @summary 忘记密码邮件发送
   * @param {SendForgetPasswordEmailReq} sendForgetPasswordEmailReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthServiceApi
   */
  public authServiceSendForgetPasswordEmail(
    sendForgetPasswordEmailReq: SendForgetPasswordEmailReq,
    options?: RawAxiosRequestConfig
  ) {
    return AuthServiceApiFp(this.configuration)
      .authServiceSendForgetPasswordEmail(sendForgetPasswordEmailReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户注册邀请
   * @summary 用户注册邀请
   * @param {AuthSendRegisterEmailReq} authSendRegisterEmailReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthServiceApi
   */
  public authServiceSendRegisterEmail(
    authSendRegisterEmailReq: AuthSendRegisterEmailReq,
    options?: RawAxiosRequestConfig
  ) {
    return AuthServiceApiFp(this.configuration)
      .authServiceSendRegisterEmail(authSendRegisterEmailReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 验证 token 是否过期
   * @summary 验证 token 是否过期
   * @param {AuthVerifyRequest} authVerifyRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthServiceApi
   */
  public authServiceVerify(authVerifyRequest: AuthVerifyRequest, options?: RawAxiosRequestConfig) {
    return AuthServiceApiFp(this.configuration)
      .authServiceVerify(authVerifyRequest, options)
      .then(request => request(this.axios, this.basePath));
  }
}
